<style scoped lang="less" >
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.v-application .text-h5 {
  font-family: "Prompt", sans-serif !important;
  font-size: 14px !important;
  text-align: right;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.legend-con {
  font-family: "Prompt", sans-serif !important;
  display: inline-block;

  ul {
    list-style: none;
  }

  li {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    span {
      display: inline-block;
    }

    span.chart-legend {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }
}
.v-data-table__wrapper > table > thead > tr {
  background-color: #039be5;
}
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  color: white !important;
}
</style>

<template>
  <v-container fluid>
    <div
      class="text-h4 font-weight-black primary--text text-spacing"
      color="blue"
    >
      รายงาน ตช.
    </div>
    <v-divider class="my-2"></v-divider>
    <v-row class="my-1">
      <v-col cols="12" lg="6" class="text-left mt-6">
        <v-text-field
          v-model="search"
          outlined
          prepend-icon="mdi-magnify"
          label="ค้นหาสถานบริการ,เลขที่เอกสาร"
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="6" class="text-right mt-6">
        <v-btn large color="default" @click="export_bill()">
          <v-icon left dark> mdi-printer </v-icon>ดาวน์โหลด Excel
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="getIndex"
      :search="search"
      item-key="index"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.index }}</td>
          <td>{{ item.T_ID }}</td>
          <td>
            {{ item.Time | formatDate }}
          </td>
          <td>{{ item.C_N }}</td>
          <td>{{ item.CAR_NUMBER }}</td>

          <td>{{ item.W_W | delimeter }}</td>
          <td>
            <v-icon small @click="printss(item)"> mdi-printer </v-icon>
          </td>
        </tr>
      </template>
      <template slot="body.append">
        <tr>
          <th colspan="2" class="text-h5 font-weight-black primary--text">
            จำนวนรวมทั้งหมด
          </th>

          <th></th>
          <th></th>
          <th></th>
          <th class="text-h5 font-weight-black primary--text">
            {{ sumField("W_W") | delimeter }}
          </th>
        </tr>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Reset </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import print_document_a5 from "./pdf/printWastDocA5";
import pdfMake from "@/assets/build/pdfmake";
import pdfFonts from "@/assets/build/vfs_fonts";
import moment from "moment";
import XLSX from "xlsx";
export default {
  components: {},
  name: "waste-report-plublic-link",
  data: () => ({
    time3: new Date(),
    isvat: "เสียภาษี",
    province: "",
    search: "",
    headers: [
      {
        text: "ลำดับ",
        align: "start",
        sortable: true,
        value: "index",
      },
      {
        text: "เลขที่เอกสาร ตช.",
        align: "start",
        sortable: true,
        value: "T_ID",
      },
      { text: "วันเก็บขน", value: "Time" },
      { text: "ชื่อแหล่งผลิต", value: "C_N" },
      { text: "รถเก็บขน", value: "CAR_NUMBER" },
      // { text: "รถเก็บถ่ายโอน", value: "CSI_CAR_N" },
      // { text: "รถเก็บขน", value: "CAR_NUMBER" },
      { text: "น้ำหนัก กก.", value: "W_W" },
      { text: "พิมพ์ ตช.", value: "actions", width: "10%" },
      // { text: "พิมพ์", value: "Time", width: "10%" },
      // { text: "จัดการข้อมูล", value: "actions" },
    ],
    table_data: [],
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date).add(543, "year").locale("th").format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    now_Date: new Date(),
    saveParam: "",
  }),
  watch: {},
  created() {
    this.initialize();
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x;
    },
    formatDate(data) {
      return moment(data).add(543, "year").format("DD-MM-YYYY");
    },
  },
  computed: {
    getIndex() {
      return this.table_data.map((item, index) => ({
        ...item,
        index: index + 1,
      }));
    },
  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
    }),
    sumField(key) {
      return this.table_data.reduce((a, b) => a + (b[key] || 0), 0);
    },

    export_bill() {
      this.LOADER(true);
      let data = this.getIndex;
      let xls_json = [];
      if (data.length > 0) {
        data.forEach((element) => {
          xls_json.push({
            ลำดับ: element.index,
            "เลขที่เอกสาร ตช.": element.T_ID,
            วันเก็บขน: moment(element.Time).format("DD-MM-YYYY"),
            ชื่อแหล่งผลิต: element.C_N,
            รถเก็บขน: element.CAR_NUMBER,
            "จำนวนน้ำหนัก (กก.)": element.W_W,
          });
        });
        var wscols = [
          { width: 5 }, // first column
          { width: 18 }, // second column
          { width: 18 }, //...
          { width: 50 },
          { width: 18 },
          { width: 18 },
        ];
        const dataWS = XLSX.utils.json_to_sheet(xls_json);
        dataWS["!cols"] = wscols;
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, `รายตช.${moment().format("DD-MM-YYYY")}.xlsx`);
        this.LOADER(false);
      } else {
        this.LOADER(false);
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาเลือกเดือนที่มีข้อมูลรายงาน`,
          timer: 2000,
        });
      }
    },
    printss(item) {
      this.print_documentpdf_a5(item);
    },
    async print_documentpdf_a5(item) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      pdfMake.createPdf(await print_document_a5(item, this.$AppName)).open();
    },
    initialize() {
      let mas = this.$route.params.l_mas;
      // for (let i = 0; i < 6; i++) {
      //   console.log(i);
      //   console.log(mas.split("&")[i]);
      // }
      const last_mas = {
        s_cs: (mas.split("&")[0] == "null" ? null : mas.split("&")[0]),
        s_d1s: (mas.split("&")[1] == "null" ? null : mas.split("&")[1]+" 00:00:00"),
        s_d2s: (mas.split("&")[2] == "null" ? null : mas.split("&")[2]+" 23:59:59"),
        s_ws: (mas.split("&")[3] == "null" ? null : mas.split("&")[3]),
        s_n: (mas.split("&")[4] == "null" ? null : mas.split("&")[4]),
        nulls: (mas.split("&")[5] == "null" ? null : mas.split("&")[5]),
      };
      console.log(last_mas);
      this.saveParam = last_mas;
      console.log("last mas");
      console.log(last_mas);
      this.LOADER(true);
      this.$guest_api
        .post(`/search_wastDocument_Report`, last_mas)
        .then((res) => {
          console.log(data);

          let data = res.data.data;
          if (data.length > 0) {
            this.table_data = data;
            this.LOADER(false);
          } else {
            this.LOADER(false);
            this.$swal({
              title: "ไม่พบข้อมูล",
              icon: "warning",
              text: `กรุณาติดต่อผู้ให้บริการ`,
              timer: 3000,
            });
          }
        })
        .catch((err) => {
          this.LOADER(false);
          this.$swal({
            title: "ไม่พบข้อมูล",
            icon: "warning",
            text: `กรุณาติดต่อผู้ให้บริการ`,
            timer: 3000,
          });
        });
    },
  },

  mounted() {},
};
</script>